import React from 'react';
import styled from 'styled-components';
import { Container, Media } from '../../components';
import { FrequentlyAskedQuestionsDesktop } from './desktop';
import { FrequentlyAskedQuestionsMobile } from './mobile';
import { FrequentlyAskedQuestionsTablet } from './tablet';

const DesktopWrapper = styled.div`
  background-color: #fff;
`;

export const FrequentlyAskedQuestions = React.forwardRef<any>((props, ref) => {
  return (
    <section ref={ref}>
      <Container>
        <Media at="sm">
          <FrequentlyAskedQuestionsMobile />
        </Media>
      </Container>
      <Container>
        <Media at="md">
          <FrequentlyAskedQuestionsTablet />
        </Media>
      </Container>
      <DesktopWrapper>
        <Container>
          <Media greaterThanOrEqual="xmd">
            <FrequentlyAskedQuestionsDesktop />
          </Media>
        </Container>
      </DesktopWrapper>
    </section>
  );
});
